import React from 'react';
import Reflux from 'reflux';
import classNames from 'classnames';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import CuesheetResponsiveActions from 'flux/actions/cuesheet/CuesheetResponsiveActions';
import CuesheetHelper from 'flux/helpers/cuesheetHelper';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import Tappable from 'react-tappable';
import CueListItemMixin from 'main/components/show/cuesheet.responsive/cueListItemMixin.jsx';

import { NoteColumnHeaderTitle } from 'flux/stores/cuesheet/CuesheetConstants';

export default React.createClass({
  mixins: [
    CueListItemMixin,
    Reflux.ListenerMixin,
    Reflux.connectFilter(CuesheetStore, 'cueState', (state) => {
      return {
        settings: state.get('settings'),
        columns: state.get('columns'),
        columnOrder: state.get('columnOrder'),
        userSettings: state.get('userSettings'),
        displayItemDescriptions: state.getIn([
          'show',
          'displayItemDescriptions',
        ]),
      };
    }),
  ],

  render() {
    let settings = this._getStateField('settings'),
      userSettings = this._getStateField('userSettings'),
      columns = this._getStateField('columns');

    if (!settings || !userSettings || !columns) return null;

    let style = {
      left: this.state.leftOffset,
      width: CuesheetHelper.getCuesheetWidth(settings, userSettings, columns),
    };

    return (
      <div className="csr-table-header-row" style={style}>
        {this._getItemHeaderCellNode()}
        {this._getItemNoteCellNode()}
        {this._getColumnCellNodes()}
      </div>
    );
  },

  componentWillMount() {
    this.setState({ leftOffset: '0px' });
  },

  componentDidMount() {
    this.listenTo(
      CuesheetResponsiveActions.scrollTableViewHorizontally,
      (val) => this.setState({ leftOffset: val }),
    );
  },

  _getItemHeaderCellNode() {
    let settings = this._getStateField('settings'),
      colWidthClass = settings.getIn(['itemColumn', 'width']);

    if (!colWidthClass) colWidthClass = 'normal';

    let colWidth = CuesheetHelper.getMobileItemColumnWidth(colWidthClass);

    return (
      <div className="csr-table-header-cell" style={{ minWidth: colWidth }}>
        <span className="csr-table-header-title">Item</span>
      </div>
    );
  },

  _getItemNoteCellNode() {
    let userSettings = this._getStateField('userSettings'),
      colWidthClass = userSettings.getIn(['noteColumn', 'width']),
      hideNotes = userSettings.getIn(['noteColumn', 'hidden']);

    if (hideNotes) return null;

    let colWidth = CuesheetHelper.getMobileNoteColumnWidth(colWidthClass);

    return (
      <div
        className={classNames('csr-table-header-cell', colWidthClass)}
        style={{ minWidth: colWidth }}
      >
        <span className="csr-table-header-title">{NoteColumnHeaderTitle}</span>
        {this._getColumnConfigCogNode()}
      </div>
    );
  },

  _getColumnConfigCogNode() {
    return (
      <Tappable onTap={CuesheetResponsiveActions.showColumnConfigModal}>
        <Icon size={2} name="cog" />
      </Tappable>
    );
  },

  _getColumnCellNodes() {
    let columns = this._getStateField('columns');

    return columns.map(this._getColumnCellNode);
  },

  _getColumnCellNode(column) {
    let colWidth = CuesheetHelper.getColumnWidth(column.get('width'));
    /**
     * colWidthClass used with inline widths to determine
     * when column titles should start ellipsis at each width
     */
    let colWidthClass = column.get('width');

    if (!column.get('width')) colWidthClass = 'normal';

    return (
      <div
        className={'csr-table-header-cell ' + colWidthClass}
        style={{ minWidth: colWidth }}
      >
        <span className="csr-table-header-title">{column.get('title')}</span>
        {this._getColumnConfigCogNode()}
      </div>
    );
  },
});
